import { React, useState, useEffect } from "react";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import SideBar from "../../Components/SideBar";
import NoResults from "../../Components/NoResults";
import { Link } from "react-router-dom";
import { BallerzToken, BallerzRedirect } from "../../Client/Ballerz.js";
import { useGetRequest } from "../../Client/index.js";
import FixtureCard from "../../Components/FixtureCard";
import MobileDropdown from "../../Components/MobileDropdown";
import MobileFooter from "../../Components/MobileFooter";
import { useLocation } from "react-router-dom";

export default function Fixtures() {
  let ballerzToken = BallerzToken();

  if (!ballerzToken) {
    BallerzRedirect();
  }

  const location = useLocation();
  const { username } = location.state || {};

  const { status, data } = useGetRequest("fixtures/list", {});

  if (status === "fetched") {
    return (
      <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
        <Header title={"fixtures"} />

        <div className="flex flex-1">
          <SideBar usernames={username} />
          <main className="flex-1 p-4 sm:p-6 grid grid-cols-1 gap-4 sm:gap-6">
            <div className="block sm:hidden">
              <MobileDropdown />
            </div>

            {data.fixtures?.length === 0 && (
              <a
                href="https://ballerz.co.uk/book-now/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../../Assets/Images/NoFixturesHL.png")}
                  alt="No results"
                  draggable={false}
                  className="hidden md:block w-[95%] h-auto mx-auto"
                />

                <img
                  src={require("../../Assets/Images/NoFixturesMobileHL.png")}
                  alt="No results"
                  draggable={false}
                  className="block md:hidden w-[95%] h-auto mx-auto"
                />
              </a>
            )}

            {data?.fixtures?.map((fixture, key) => (
              <FixtureCard fixture={fixture} />
            ))}

            <div className="block sm:hidden">
              <MobileFooter />
            </div>
          </main>
        </div>
      </div>

      // return (
      //   <div>
      //     <div className="DashboardTemplate">
      //       <div
      //         data-testid="PortalTwoColumnPageLayout"
      //         className="PortalTwoColumnPageLayout flex min-h-screen flex-col"
      //       >
      //         <Header />

      //         <div
      //           data-testid="TwoColumnPageLayout"
      //           className="TwoColumnPageLayout max-w-[100vw] flex-1 bg-[#0F0F0F]"
      //         >
      //           <div
      //             data-testid="SectionContainer"
      //             className="SectionContainer mx-auto px-[10px] pb-[60px] pt-[20px] md:px-[20px] lg:px-[20px] xl:pt-0  min-h-screen max-w-[1440px]"
      //           >
      //             <div className="flex flex-col pb-0 md:flex-row lg:pt-[70px]">
      //               <SideBar />

      //               {data?.count === 0 && (
      //                 <div className="w-full">
      //                   <NoResults title="You have not played any fixtures yet" />
      //                 </div>
      //               )}

      //               {status === "fetching" && (
      //                 <div className="flex justify-center items-center w-full h-screen text-white">
      //                   <ClipLoader
      //                     color={"green"}
      //                     size={150}
      //                     aria-label="Loading Spinner"
      //                     data-testid="loader"
      //                   />
      //                 </div>
      //               )}

      //               {status === "fetched" && data?.count && (
      //                 <div className="flex flex-col w-full">
      //                   <div className="flex flex-row flex-wrap">
      //                     {data?.fixtures?.map((fixture, key) => (
      //                       <div
      //                         key={key}
      //                         className="bg-[#0F0F0F] text-white p-6 w-1/2 max-w-4xl mx-auto"
      //                       >
      //                         <Link to={`/fixture/${fixture.id}`}>
      //                           <div className="bg-[#2b2b2b] p-8 rounded-md">
      //                             <div className="flex justify-between items-start mb-6">
      //                               <h2 className="text-[#4650f0] font-bold DrukWide text-lg sm:text-2xl">
      //                                 {dateFormat(
      //                                   fixture.fixture_date,
      //                                   "mmmm dS, yyyy"
      //                                 )}
      //                               </h2>
      //                               <span className="text-gray-400 font-semibold text-lg DrukWide">
      //                                 FT
      //                               </span>
      //                             </div>

      //                             <div className="flex flex-col gap-6">
      //                               <div className="flex justify-between items-center">
      //                                 <span className="text-white text-lg sm:text-xl font-semibold tracking-wide DrukWide">
      //                                   {fixture.home.name}
      //                                 </span>
      //                                 <span className="text-white text-2xl font-bold DrukWide">
      //                                   {fixture.home.score}
      //                                 </span>
      //                               </div>
      //                               <div className="flex justify-between items-center">
      //                                 <span className="text-white text-lg sm:text-xl font-semibold tracking-wide DrukWide">
      //                                   {fixture.away.name}
      //                                 </span>
      //                                 <span className="text-white text-2xl font-bold DrukWide">
      //                                   {fixture.away.score}
      //                                 </span>
      //                               </div>
      //                             </div>
      //                           </div>
      //                         </Link>
      //                       </div>
      //                     ))}
      //                   </div>
      //                 </div>
      //               )}
      //             </div>
      //           </div>
      //         </div>

      //         <Footer />
      //       </div>
      //     </div>
      //   </div>
    );
  }
}
